import { isRouteErrorResponse, useRouteError } from 'react-router-dom'
import { HttpErrorKind, HttpErrorPage, httpErrorKindForStatus } from '@/pages/errors/HttpError'
import { reloadPage } from './reload'

/**
 * The error boundary of every top-level route (TO-640 http-error-pages
 * REQ-003): a route whose loader or render throws shows the matching family
 * card in place, at the same URL, instead of the router's built-in screen.
 *
 * The thrown value only picks the kind — its message, stack and data are never
 * rendered (REQ-004).
 */
export function RouteErrorPage() {
	const error = useRouteError()
	const kind = isRouteErrorResponse(error) ? httpErrorKindForStatus(error.status) : HttpErrorKind.Unexpected
	return <HttpErrorPage kind={kind} onRetry={reloadPage} />
}
